import { Dispatch } from "redux";

import { intervalsApi } from "./api";
import { intervalsActions } from "./slice";
import { RootState } from "app/store/rootReducer";

import { IIntervalsRequest } from "./types";

import { generateStorageKey } from "utils/helpers/generateStorageKey";

export const getIntervals = (props: IIntervalsRequest) => (dispatch: Dispatch, getState: () => RootState) => {
  const key = generateStorageKey({
    startAt: props.start_at,
    endAt: props.end_at,
    sectionId: props.sectionId,
    type: props.structure,
    buildingId: props.buildingId,
  });
  if (!getState().intervalsReducer.intervals[key]) {
    //
  }
  intervalsApi
    .getIntervals(props)
    .then(({ data }) => {
      console.log(data);
      //
    })
    .finally(() => {
      //
    });
};

export const getAllIntervals =
  (props: Omit<IIntervalsRequest, "type">) => async (dispatch: Dispatch, getState: () => RootState) => {
    const key = generateStorageKey({
      startAt: props.start_at,
      endAt: props.end_at,
      sectionId: props.sectionId,
      type: props.structure,
      buildingId: props.buildingId,
    });
    //loading
    const res = await Promise.all([
      intervalsApi.getIntervals({ ...props, type: "plan" }),
      intervalsApi.getIntervals({ ...props, type: "progress" }),
    ]);
    dispatch(intervalsActions.setIntervals({ key, intervals: { ...(res[0]?.data ?? {}), ...(res[1]?.data ?? {}) } }));
    //loading
  };
